import React from "react";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  ButtonGroup,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
import classNames from "classnames";

// Requests
import { getClientRequest } from 'api/client';
// Components
import StageOfSalesWizard from "components/ClientDetails/StageSales/Wizard.js";
import SOA from "components/ClientDetails/SOA/SOA";
import History from "components/History/History";
import PersonalInformation from "components/ClientDetails/Tabs/PersonalInformation";
import Contract from "components/ClientDetails/Tabs/Contract";
import WorkOccupation from "components/ClientDetails/Tabs/WorkOccupation";
import FinancialInformation from "components/ClientDetails/Tabs/FinancialInformation";
import SpouseDependants from "components/ClientDetails/Tabs/SpouseDependants";
import Attorney from "components/ClientDetails/Tabs/Attorney";
import CoBorrowers from "components/ClientDetails/Tabs/CoBorrowers";

class ClientDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: null,
      logs: null,
      addingEntry: false,
      newEntryText: "",
      saving: false,
      horizontalTabs: "information",
      tableInfo: "personal",
    };
  }

  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");

    if (id) {
      const client = await getClientRequest(id);
      this.setState({
        client,
      });
    } else {
      this.goTo("/clients");
    }
  }

  goTo = (path) => this.props.history.push(path);

  changeActiveTab = (e, tabState, tadName) => {
    e.preventDefault();
    this.setState({
      [tabState]: tadName,
    });
  };
  changeTableInfo = async (e, tabState, tadName) => {
    e.preventDefault();
    this.setState({
      [tabState]: tadName,
    });
  };

  updateClient = (client) => {
    this.setState({
      client
    });
  }

  renderActiveTab = (activeTab) => {
    const { client } = this.state;

    switch (activeTab) {
      case "information":

        const subtabs = [ 
          {
            title: "Personal Information",
            type: "personal"
          },
          {
            title: "Contract",
            type: "contract"
          },
          {
            title: "Work & Occupation",
            type: "workOccupation"
          },
          {
            title: "Financial Information",
            type: "financial"
          },
          {
            title: "Spouse & Dependants",
            type: "spouseDependants"
          },
          {
            title: "Attorney-in-Fact",
            type: "attorney"
          },
          {
            title: "Co-borrowers",
            type: "coBorrowers"
          },
    
        ]

        return (
          <>
            <ButtonGroup
              className="btn-group-toggle float-left"
              data-toggle="buttons"
            >
              {subtabs.map((tab) => {
                return (
                  <Button
                    key={tab.type}
                    color="info"
                    id="0"
                    size="sm"
                    tag="label"
                    className={classNames("btn-simple", {
                      active: this.state.tableInfo === tab.type,
                    })}
                    onClick={(e) =>
                      this.changeTableInfo(e, "tableInfo", tab.type)
                    }
                  >
                    <input defaultChecked name="options" type="radio" />
                    <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                      {tab.title}
                    </span>
                    <span className="d-block d-sm-none">
                      <i className="tim-icons icon-single-02" />
                    </span>
                  </Button>
                )
              })}
            </ButtonGroup>
            <br />
            <br />
            {!client ? (
              <div>Loading...</div>
            ) : (
              <>
                  {this.renderActivSubTab(this.state.tableInfo)}
              </>
            )}
          </>
        )
      case "SOA":
        return (
          <>
            { client ?
              <SOA client={client} /> : null
            }
          </>
        )
      case "StagesOfSale":
        return (
          <>
            <StageOfSalesWizard client={client} updateClient={this.updateClient} />
          </>
        )
      case "history":
        return <History location={this.props.location} component={client} type={'client'} />
      default: 
          return (
            <>
            { client ?
              <SOA client={client} /> : null
            }
          </>
          )
    }
  }

  renderActivSubTab = (tab) => {
    const {
      _id,
      first_name,
      last_name,
      middle_name,
      civil_status,
      age,
      gender,
      birthday,
      nationality,
      tin,
      email,
      phone, 
      address,
      status,
      refund_amount,
      home_owner,
      owned_date,
      is_rto,
      financingType,
      financingSubtype,
      block_number,
      lot_number,
      model_unit,
      lot_area,
      reservation_date,
      payment_term,
      created_at,
      updated_at,
      occupation,
      companyName,
      companyAddress,
      companyContact,
      companyEmail,
      businessNature,
      jobTitle,
      experience,
      salary,
      spouseSalary,
      coBorrowerSalary,
      overtime,
      allowances,
      otherIncome,
      total,
      spouse,
      spouseOccupation,
      dependents,
      attorney,
      coBorrowers,
      seller,
      unit,
      project
    } = this.state.client;

    switch(tab) {
      case "personal":
        return (
          <PersonalInformation client={{
              _id,
              first_name,
              last_name,
              middle_name,
              civil_status,
              age,
              gender,
              birthday,
              nationality,
              tin,
              email,
              phone, 
              address,
              status,
              refund_amount,
              home_owner,
              owned_date,
              is_rto,
              block_number,
              lot_number,
              model_unit,
              lot_area,
              reservation_date,
              payment_term,
              seller,
              project,
              created_at,
              updated_at
            }}
          />
        );
      case "contract":
        return (
          <Contract client={{
              unit,
              project
            }} 
          />
        );
      case "workOccupation":
        return (
          <WorkOccupation client={{
              occupation,
              companyName,
              companyAddress,
              companyContact,
              companyEmail,
              businessNature,
              jobTitle,
              experience
            }} 
          />
        );
      case "financial":
        return (
          <FinancialInformation client={{
              salary,
              spouseSalary,
              coBorrowerSalary,
              overtime,allowances,
              otherIncome,
              total,
              financingType,
              financingSubtype,
            }} 
          />
        );
      case "spouseDependants":
        return (
          <SpouseDependants client={{
              spouse,
              spouseOccupation,
              dependents
            }} 
          />
        );
      case "attorney":
        return <Attorney client={{attorney}} />;
      case "coBorrowers":
        return <CoBorrowers client={{coBorrowers}} />;
      default:
        console.error("Have a bug in switch tabs information")
    }
  }

  render() {

    const { client = {} } = this.state;
    
    const tabs = [
      {
        title: "Information",
        type: "information"
      },
      {
        title: "SOA",
        type: "SOA"
      },
      {
        title: "Stages of Sale",
        type: "StagesOfSale"
      },
      {
        title: "History",
        type: "history"
      },
    ]

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader className="mb-2">
                  <CardTitle tag="h3">
                    Client Details
                    <Button
                      className="float-right"
                      color="default"
                      onClick={() => this.goTo("/clients")}
                    >
                      Back
                    </Button>                    
                    <Button
                      className="float-right mr-2"
                      color="default"
                      onClick={() => this.goTo(`/client/edit?id=${client._id}`)}
                    >
                      Edit
                    </Button>
                  </CardTitle>
                  <Nav className="nav-pills-info" pills>
                    {tabs.map((tab) => {
                      return (
                        <NavItem key={tab.title}>
                          <NavLink
                            data-toggle="tab"
                            href="#pablo"
                            className={
                              this.state.horizontalTabs === tab.type
                                ? "active"
                                : ""
                            }
                            onClick={(e) =>
                              this.changeActiveTab(
                                e,
                                "horizontalTabs",
                                tab.type
                              )
                            }
                          >
                            {tab.title}
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </Nav>
                </CardHeader>
                <CardBody>
                  {this.renderActiveTab(this.state.horizontalTabs)}
                </CardBody>
                    
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default ClientDetails;
